import type { UIMessage } from "@ai-sdk/react"
import { useEffect, useRef } from "react"

import { getAiSuggestionIdFromMessage } from "~components/shared/chat/chat-helpers"

export default function useAutoPreviewSuggestion({
    shouldAutoPreviewSuggestions,
    messages,
    setSelectedAiSuggestionId,
    lastSelectedAiSuggestionId,
}: {
    shouldAutoPreviewSuggestions: boolean
    messages: UIMessage[]
    setSelectedAiSuggestionId: (aiSuggestionId: string) => void
    lastSelectedAiSuggestionId: string | null
}) {
    const prevSuggestionIdRef = useRef<string | null>(null)

    useEffect(() => {
        if (!shouldAutoPreviewSuggestions) return

        const lastMessage = messages[messages.length - 1]
        const suggestionId = lastMessage
            ? getAiSuggestionIdFromMessage(lastMessage)
            : null
        const isSameSuggestionId = suggestionId === prevSuggestionIdRef.current
        const hasBeenApplied = suggestionId === lastSelectedAiSuggestionId

        if (!suggestionId || isSameSuggestionId || hasBeenApplied) return

        // Update the previous suggestion id reference and auto select.
        prevSuggestionIdRef.current = suggestionId
        setSelectedAiSuggestionId(suggestionId)
    }, [messages])
}
